import { AspectRatio as ChakraAspectRatio, AspectRatioProps } from '@chakra-ui/layout'
import * as React from 'react'

import { getRadiusValue, TRadius } from '~ui/styleGuide/radiuses'
import { aspectRatios, TAspectRatio } from '~ui/styleGuide/styles'

type TChakraProps = Pick<AspectRatioProps, 'width' | 'height' | 'maxWidth'>

type TProps = RequiredChildren &
  TChakraProps & {
    /** the ration (key) that the content wrapped by this component should keep */
    ratio?: TAspectRatio
    /** the border radius of the component */
    radius?: TRadius
  }

/**
 * abstraction on top of Chakra’s AspectRatio component
 * renders Image passed as children prop in given aspect ratio (default is square ratio)
 */
export const AspectRatio: React.FC<TProps> = ({
  children,
  ratio = `square`,
  radius,
  ...chakraProps
}) => {
  const radiusValue = radius ? getRadiusValue(radius) : undefined

  return (
    <ChakraAspectRatio
      {...chakraProps}
      ratio={aspectRatios[ratio]}
      borderRadius={radiusValue}
      overflow={`hidden`}
    >
      {children}
    </ChakraAspectRatio>
  )
}
